/**
 * Teilen eines Links auf die Webseite, eine Reise oder einen Zwischenhalt (UC-018, docs/ux-design.md 5.6):
 * mit der Teilen-Funktion des Geräts, sonst über die Zwischenablage (A1), sonst erscheint der Link markiert
 * zum Kopieren (A2).
 */
export type Ergebnis = 'geteilt' | 'abgebrochen' | 'kopiert' | 'manuell';

/** Ausschnitt von navigator, damit Tests die Fähigkeiten des Geräts vorgeben können */
export interface Geraet {
  share?: (daten: ShareData) => Promise<void>;
  clipboard?: Pick<Clipboard, 'writeText'>;
}

/** Wie lange «Link kopiert» sichtbar bleibt */
export const BESTAETIGUNG_MS = 3000;

export async function teilen(url: string, titel: string, geraet: Geraet): Promise<Ergebnis> {
  if (typeof geraet.share === 'function') {
    try {
      await geraet.share({ title: titel, url });
      return 'geteilt';
    } catch (error_) {
      // Der Besucher hat das Teilen abgebrochen; sonst (z. B. NotAllowedError) die Zwischenablage versuchen
      if (error_ instanceof DOMException && error_.name === 'AbortError') {
        return 'abgebrochen';
      }
    }
  }
  if (typeof geraet.clipboard?.writeText === 'function') {
    try {
      await geraet.clipboard.writeText(url);
      return 'kopiert';
    } catch {
      // Zugriff verweigert, z. B. ohne HTTPS: A2
    }
  }
  return 'manuell';
}

/**
 * Richtet den Knopf «Teilen» in einem Bereich mit data-teilen-url und data-teilen-titel ein.
 */
export function teilenEinrichten(bereich: HTMLElement, geraet: Geraet = navigator): void {
  const knopf = bereich.querySelector<HTMLButtonElement>('[data-teilen-knopf]');
  const bestaetigung = bereich.querySelector<HTMLOutputElement>('[data-teilen-bestaetigung]');
  const link = bereich.querySelector<HTMLInputElement>('[data-teilen-link]');
  const url = bereich.dataset.teilenUrl;
  if (!knopf || !bestaetigung || !link || !url) {
    return;
  }
  const titel = bereich.dataset.teilenTitel ?? document.title;
  let ausblenden: ReturnType<typeof setTimeout> | undefined;

  knopf.addEventListener('click', async () => {
    const ergebnis = await teilen(url, titel, geraet);
    if (ergebnis === 'kopiert') {
      bestaetigung.textContent = 'Link kopiert';
      clearTimeout(ausblenden);
      ausblenden = setTimeout(() => {
        bestaetigung.textContent = '';
      }, BESTAETIGUNG_MS);
    } else if (ergebnis === 'manuell') {
      link.value = url;
      link.hidden = false;
      link.focus();
      link.select();
    }
  });
}
